import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LeadFinder from "./components/leadfinder/LeadFinder";
import { Toaster } from "./components/ui/toaster";

function App() {
  useEffect(() => {
    document.title = "Geokath Lead Finder";
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LeadFinder />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
